exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".k-between-input-container{display:flex}.k-between-input-container .k-filter-input .v-input__slot{max-width:calc(50% - 12.5px)}\n", ""]);

// exports
